<script lang="ts">
  import type { LoginFormHandler } from '@athena-lib/LoginForm';
  import type { LoginFormTrackingEvent } from '@athena-lib/LoginForm/types';
  import CreateAccount from './CreateAccount.svelte';
  import Login from './Login.svelte';
  import ResetPassword from './ResetPassword.svelte';
  import { type LoginFormTrackingHandler } from './types';

  type Props = {
    onLogin: LoginFormHandler;
    onResetPassword: LoginFormHandler;
    onCreateAccount: LoginFormHandler;
    googleLoginHref: string;
    onTracking?: (message: LoginFormTrackingEvent) => void;
  };

  type Screen = 'login' | 'reset_password' | 'create_account';

  const { onLogin, onCreateAccount, onResetPassword, googleLoginHref, onTracking }: Props =
    $props();

  let screen = $state<Screen>('login');

  const goToLogin = () => (screen = 'login');
  const goToResetPassword = () => (screen = 'reset_password');
  const goToCreateAccount = () => (screen = 'create_account');

  const triggeredEventActions: string[] = [];

  const onFormTracking: LoginFormTrackingHandler = (
    action: string,
    type: string,
    repeat: boolean,
  ) => {
    if (onTracking) {
      const eventAction = `${type}_form_${action}`;
      if (repeat || !triggeredEventActions.includes(eventAction)) {
        onTracking({
          event_action: eventAction,
          event_group: `${type}_form`,
          event_variant: 'login_modal',
        });
        triggeredEventActions.push(eventAction);
      }
    }
  };
</script>

<div class="px-5 pb-5 pt-14">
  {#if screen === 'login'}
    <Login {onLogin} {goToResetPassword} {goToCreateAccount} {googleLoginHref} {onFormTracking} />
  {:else if screen === 'reset_password'}
    <ResetPassword {goToLogin} {onResetPassword} {onFormTracking} />
  {:else if screen === 'create_account'}
    <CreateAccount {goToLogin} {onCreateAccount} {onFormTracking} />
  {/if}
</div>
